import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL, listAll } from "firebase/storage";

const firebaseConfig = {
    // apiKey: "AIzaSyA4oFDtAa8Rqrq78DVoGKRflO-3cVjYjes",
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: "andriodapp-50f04.firebaseapp.com",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: "andriodapp-50f04",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: "andriodapp-50f04.appspot.com",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: "748520318764",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    // appId: "1:748520318764:web:69f22c862aae8b5f45ae89",
    appId: process.env.REACT_APP_FIREBASE_APP_ID, 
    // measurementId: "G-PCCVTL1BQD"
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId:process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ,
    // appId: process.env.REACT_APP_FIREBASE_APP_ID ,
    // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    // apiKey: import.meta.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: import.meta.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId:import.meta.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ,
    // appId: import.meta.env.REACT_APP_FIREBASE_APP_ID ,
    // measurementId: import.meta.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export { storage, ref, uploadBytes, getDownloadURL, listAll };
